<template>
  <div class="not-found">
    <h1>{{ errorMessage }}</h1>
    <div class="links">
      <router-link :to="{ name: 'Login'}" v-if="!loggedIn && validSite">
        Login
      </router-link>
      <router-link :to="{ name: 'Dashboard' }" v-if="loggedIn && validSite">
        Dashboard
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      errorMessage: ''
    }
  },

  computed: {
    ...mapGetters({
      websiteConfig: 'websiteConfig'
    })
  },

  beforeMount () {
    var token = this.$route.query.token
    if (token !== '' && token !== null && typeof token !== 'undefined') {
      localStorage.setItem(
        'token_' + this.websiteConfig.id,
        token
      )
      // Adding localStorage item instead of a calling to a mutation because this will be lost on
      // page reload and it should persist across the app until logout is called
      localStorage.setItem(
        'impersonate_' + this.websiteConfig.id,
        true
      )
      this.UPDATE_LOGIN_STATUS(true)
      this.WEBSITE_CONFIG_AUTH_UPDATE(this.$router).then(() => {
        this.$router.push({ name: 'Dashboard' })
        return
      })
    } else {
      this.errorMessage = 'Token not valid'
    }
  },

  methods: {
    ...mapActions([
      'WEBSITE_CONFIG_AUTH_UPDATE'
    ]),
    ...mapMutations([
      'UPDATE_LOGIN_STATUS'
    ])
  }
}
</script>

<style lang="sass" scoped>
.not-found
  text-align: center
</style>



// WEBPACK FOOTER //
// Impersonate.vue?685852a9